<template>
  <v-app-bar
    clipped-left
    app
    dark
    height='60'
    fixed
  >
    <v-app-bar-nav-icon @click="toggleSidebar" v-if="loggedIn">
      <v-icon>menu</v-icon>
    </v-app-bar-nav-icon>
    <v-toolbar-title>
      <v-container>
        <v-img
          class="logo mr-2"
          src="../../assets/logo.png"
          contain
          height="40"
          width="40"
          alt="Buzz Solutions"
          @click="$router.push({ name: 'Landing' }).catch((e) => e)"
          style="cursor:pointer"
        ></v-img>
      </v-container>
    </v-toolbar-title>
    <v-toolbar-items v-if="!isMobile">
      <!-- <v-select
        v-if="loggedIn && showProjectsOnThisRoute"
        :items="projects"
        item-value="pid"
        item-text="name"
        :value="currentProject"
        id="projects-select"
        class="mt-3"
        @change="enterProject"
        solo
        dense
        :loading="loadingProjects"
      ></v-select> -->
      <RedirectByProject />
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-tab
        v-for="tab in tabList"
        :key="tab.title"
        ripple
        :to="tab.path"
        class="navbar-tab"
        @click="onClickTab(tab.title)"
      >
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import links from '@components/layouts/links';
import { uniqueArrayBy, flattenArray } from '@methods/helpers';
import RedirectByProject from '@components/layouts/RedirectByProject.vue';

export default {
  name: 'Navbar',
  props: ['isMobile', 'drawerStatus'],
  components: {
    RedirectByProject,
  },
  data: () => ({
    projects: [],
    window: {
      width: 0,
      height: 0,
    },
    miniSidebar: false,
    drawer: true,
    showProjectsOnThisRoute: true,
  }),
  methods: {
    ...mapActions(['logout', 'getAllProjectsByCompanyId', 'getProjectsByDocRefs']),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    toggleSidebar() {
      this.drawer = !this.drawer;
      this.$emit('toggleSidebar', this.drawer);
    },
    adjustSidebar() {
      this.miniSidebar = !this.miniSidebar;
      this.$emit('toggleSidebar', !this.miniSidebar);
    },
    enterProject(pid) {
      this.$router.push({ name: 'Redirect', params: { pid, name: this.$route.name } });
    },
    async onClickTab(tabTitle) {
      if (tabTitle === 'Logout') {
        await this.logout();
        this.$router.push({ name: 'Login' });
      }
    },
    showProjects() {
      const blackList = ['InsightsContent'];
      this.showProjectsOnThisRoute = !blackList.includes(this.$route.name);
    },
  },
  computed: {
    ...mapGetters(['loggedIn', 'currentUser', 'allProjects', 'currentProject', 'loadingProjects', 'allTeams', 'firstFactorAuthenticated', 'secondFactorAuthenticated']),
    tabList() {
      let tabs;

      if (this.authenticationLevel === 'Authenticated') {
        tabs = links.auth;
        const settingsTabIndex = tabs.findIndex((tab) => tab.title === 'Settings');
        tabs[settingsTabIndex].path = `/settings/user/${this.currentUser.uid}/profile`;
      } else if (this.authenticationLevel === 'First Factor Authenticated') {
        const [logoutTab] = links.auth.filter((link) => link.title === 'Logout');
        tabs = [logoutTab];
      } else {
        tabs = links.guest;
      }

      if (this.isMobile) return [];
      return tabs;
    },
    activeProject() {
      return this.$route.name === 'Project' ? this.currentProject : null;
    },
    authenticationLevel() {
      if (this.loggedIn) return 'Authenticated';
      if (this.firstFactorAuthenticated && !this.secondFactorAuthenticated) return 'First Factor Authenticated';
      return 'Not Authenticated';
    },
    // showClientLogo() {
    //   return window.location.hostname === 'newfoundland.buzzpowerai.com';
    // },
  },
  watch: {
    drawerStatus(newStatus) {
      this.drawer = newStatus;
    },
    $route() {
      this.showProjects();
    },
  },
  async created() {
    this.showProjects();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    if (this.loggedIn && this.allProjects.length === 0) {
      if (this.currentUser.adminStatus) {
        const res = await this.getAllProjectsByCompanyId(this.currentUser.cid);
        this.projects = res.data;
      } else {
        const projects = uniqueArrayBy(flattenArray(this.allTeams
          .map((team) => team.projects)
          .filter((projectsList) => projectsList.length > 0)), 'id');
        this.projects = await this.getProjectsByDocRefs(projects);
      }
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
